import { TBrodMigdalValue } from '../../../../../../../generic/hooks/useBrodMigdal'

export const toGroupID = (value: TBrodMigdalValue): number => {
    const n = Number(value)
    return Number.isFinite(n) ? n : 0
}

// BM value is a comma-separated id list ('1,3'); empty / non-string / any
// unexpected character rejects the whole string (no restriction, no crash).
const GROUP_IDS_PATTERN = /^\d+(,\d+)*$/

export const parseGroupIDs = (value: TBrodMigdalValue): number[] => {
    if (typeof value !== 'string') return []
    const s = value.trim()
    if (!GROUP_IDS_PATTERN.test(s)) return []
    return s.split(',').map(Number)
}

export const filterByGroupIDs = <T extends { GroupID?: number[] }>(items: T[], groupIDs: number[]): T[] => {
    if (groupIDs.length === 0) return items
    return items.filter((item) => (item.GroupID ?? []).some((g) => groupIDs.includes(g)))
}

export const filterByGroupID = <T extends { GroupID?: number | number[] }>(items: T[], groupID: number): T[] => {
    if (groupID === 0) return items
    return items.filter((item) =>
        Array.isArray(item.GroupID)
            ? item.GroupID.some((g) => g === groupID)
            : item.GroupID === groupID
    )
}
